import * as actions from "../constants/actionTypes";

export const INITIAL_STATE = {
    contestants: { list: [] },
    contest: { list: [] },
    voter: { list: [] },
    contestantsHasMore: true,
    contestHasMore: true,
    voterHasMore: true,
    contestantsLoad: true,
    contestLoad: true,
    voterLoad: true,
    keyword: '',
    type: 'contestant',
    filterChange:false,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.SEARCH_TEXT:
            return {
                ...state,
                keyword: action.payload
            }

        case actions.SEARCH_TYPE:
            return {
                ...state,
                type: action.payload
            }
        case actions.GET_SEARCH_CONTESTANTS_DATA_SUCCESS:
            let { newData } = action.payload;
            let contestantsLength = action.payload.data.list != undefined ? !newData ? state.contestants.list.length + action.payload.data.list.length : action.payload.data.list.length : 0;
			localStorage.setItem("loadMoreSearch", false);

            return {
                ...state,
                contestants: action.payload.data.list != undefined
                    ? !newData
                        ? { list: [...state.contestants.list, ...action.payload.data.list], totalRecords: action.payload.data.totalRecords }
                        : { list: [...action.payload.data.list], totalRecords: action.payload.data.totalRecords }
                    : { list: state.contestants.list.length == 0 ? [] : newData ? [] : state.contestants.list },
                contestantsHasMore: action.payload.data.list != undefined ? contestantsLength < action.payload.data.totalRecords[0].count : false,
                contestantsLoad: false,
                filterChange: false
            }

        case actions.GET_SEARCH_CONTEST_DATA_SUCCESS:
            let { newData: newDataContest } = action.payload;
            let contestLength = action.payload.data.list != undefined ? !newDataContest ? state.contest.list.length + action.payload.data.list.length : action.payload.data.list.length : 0;
			localStorage.setItem("loadMoreSearch", false);

            return {
                ...state,
                contest: action.payload.data.list != undefined
                    ? !newDataContest
                        ? { list: [...state.contest.list, ...action.payload.data.list], totalRecords: action.payload.data.totalRecords }
                        : { list: [...action.payload.data.list], totalRecords: action.payload.data.totalRecords }
                    : { list: state.contest.list.length == 0 ? [] : newData ? [] : state.contest.list },
                contestHasMore: action.payload.data.list != undefined ? contestLength < action.payload.data.totalRecords[0].count : false,
                contestLoad: false,
            }

        case actions.GET_SEARCH_VOTER_DATA_SUCCESS:
            let { newData: newDataVoter } = action.payload;
            let voterLength = action.payload.data.list != undefined ? !newDataVoter ? state.voter.list.length + action.payload.data.list.length : action.payload.data.list.length : 0;
			localStorage.setItem("loadMoreSearch", false);

            return {
                ...state,
                voter: action.payload.data.list != undefined
                    ? !newDataVoter
                        ? { list: [...state.voter.list, ...action.payload.data.list], totalRecords: action.payload.data.totalRecords }
                        : { list: [...action.payload.data.list], totalRecords: action.payload.data.totalRecords }
                    : { list: state.voter.list.length == 0 ? [] : newData ? [] : state.voter.list },
                voterHasMore: action.payload.data.list != undefined ? voterLength < action.payload.data.totalRecords[0].count : false,
                voterLoad: false,
            }
        case actions.FILTER_LIST_DATA: {
            return {
                ...state,
                filterChange: true,
            }
        }
        default:
            return state;
    }
}